import Axios from 'axios';

export interface StockReminderRequestModel {
    productId: string;
    email: string;
}

export default class StockReminderService {
    private profileId: string = (window as any).CbxApiContextKey;
    private endpoint: string;

    constructor(args: any = {}) {
        if (args.profileId) this.profileId = args.profileId;
        this.endpoint = `/contextapi/${this.profileId}/v1/stock-reminder`;
    }

    public async add(data: StockReminderRequestModel): Promise<boolean> {
        try {
            await Axios({
                method: 'POST',
                url: `${this.endpoint}/add`,
                data,
            });
            return true;
        } catch (error) {
            return false;
        }
    }
}
